import {
  CE_DIRECTORY_FORMATS,
  CE_DIRECTORY_GROUPS,
  CE_DIRECTORY_SCOPES,
  CeDirectoryFilters,
} from './types';

export const DEFAULT_CE_DIRECTORY_FILTERS: CeDirectoryFilters = {
  group: 'all',
  format: 'all',
  scope: 'province_state',
};

const STORAGE_PREFIX = 'tempstars.ce-directory.filters';
const STORAGE_VERSION = 1;

function storageKey(userId: number | string): string {
  return `${STORAGE_PREFIX}.v${STORAGE_VERSION}.${encodeURIComponent(String(userId))}`;
}

function isValidFilters(value: unknown): value is CeDirectoryFilters {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return false;
  const filters = value as Partial<CeDirectoryFilters>;
  return CE_DIRECTORY_GROUPS.includes(filters.group as any)
    && CE_DIRECTORY_FORMATS.includes(filters.format as any)
    && CE_DIRECTORY_SCOPES.includes(filters.scope as any);
}

export function readCeDirectoryFilters(
  userId: number | string,
  storage: Pick<Storage, 'getItem'> = window.localStorage,
): CeDirectoryFilters {
  try {
    const raw = storage.getItem(storageKey(userId));
    if (!raw) return { ...DEFAULT_CE_DIRECTORY_FILTERS };
    const envelope = JSON.parse(raw);
    if (envelope?.version !== STORAGE_VERSION
        || envelope?.userId !== String(userId)
        || !isValidFilters(envelope?.filters)) {
      return { ...DEFAULT_CE_DIRECTORY_FILTERS };
    }
    return { ...envelope.filters };
  } catch (_error) {
    return { ...DEFAULT_CE_DIRECTORY_FILTERS };
  }
}

export function writeCeDirectoryFilters(
  userId: number | string,
  filters: CeDirectoryFilters,
  storage: Pick<Storage, 'setItem'> = window.localStorage,
): void {
  if (!isValidFilters(filters)) return;
  try {
    storage.setItem(storageKey(userId), JSON.stringify({
      version: STORAGE_VERSION,
      userId: String(userId),
      filters,
    }));
  } catch (_error) {
    // Storage can be unavailable in private browsing. Filters still work in-memory.
  }
}
